import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { DefaultListBase, DefaultVirtualizedListBase } from './components';
export var listDefaultTopModelsObject = {
    ListBase: React.createElement(TopModel, { name: "ListBase" }, DefaultListBase),
};
export var virtualizedListDefaultTopModelsObject = {
    ListBase: React.createElement(TopModel, { name: "ListBase" }, DefaultVirtualizedListBase),
};
